import MobileStepper from '@mui/material/MobileStepper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {FiveStarsEnum} from 'main/analytics/gaTagsEnum';
import React from 'react';
import {StepProgressBarProps} from './types';

export function StepProgressBar({currentStep, totalSteps, ...stackProps}: StepProgressBarProps) {
	return (
		<Stack direction="row" alignItems="center" gap={2} {...stackProps}>
			<MobileStepper
				activeStep={currentStep}
				steps={totalSteps + 1}
				backButton={null}
				nextButton={null}
			/>
			<Typography
				data-tag-id={FiveStarsEnum.ETAPAS_5_ESTRELAS}
				variant="body2"
				color="white">{`Etapa ${currentStep} de ${totalSteps}`}</Typography>
		</Stack>
	);
}
